import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // variável de ambiente
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // formato correto
  }
  return config;
});

export default api;
